import { motion } from 'framer-motion';

export function ImagePreview({ imageData }) {
  if (!imageData) return null;

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      className="rounded-lg overflow-hidden shadow-lg"
    >
      <img
        src={imageData}
        alt="Plant preview"
        className="w-full h-64 object-cover"
      />
    </motion.div>
  );
}